import { SortableTable } from '@/common/ui/table/sortable-table'
import { columns } from './constants'
import { GetDynamicPageByIdDataResponse } from '@/modules/client-setting/type'
import { SortableRow } from './SortableRow'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'
import useMutationUpdateSectionOrderInPage from '@/modules/client-setting/api/hooks/useMutationUpdateSectionOrderInPage'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface DynamicPageByIdTableProps {
	data: GetDynamicPageByIdDataResponse[]
	total: number
	isLoading?: boolean
}

export default function DynamicPageByIdTable({
	data,
	total,
	isLoading,
}: DynamicPageByIdTableProps) {
	const { data: user } = useQueryProfile()
	const { mutateAsync: updateSectionOrder } =
		useMutationUpdateSectionOrderInPage()
	const queryClient = useQueryClient()

	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.WEB_SETTING,
	)

	const handleOrderChange = async (
		_newData: GetDynamicPageByIdDataResponse[],
		movedItem: GetDynamicPageByIdDataResponse,
		newIndex: number,
	) => {
		if (!hasWritePermission) return

		try {
			await updateSectionOrder({
				dynamicPageSectionId: movedItem.id,
				payload: {
					order: newIndex + 1,
				},
			})
			queryClient.invalidateQueries({
				queryKey: [
					DynamicPageQueryKeys.GetDynamicPageById,
					movedItem.dynamicPageId,
				],
			})
			toast.success('อัพเดทลำดับสำเร็จ')
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	return (
		<div className="space-y-4">
			<SortableTable
				data={data}
				columns={columns}
				searchPlaceholder="ค้นหาเซคชั่น"
				onOrderChange={handleOrderChange}
				SortableRowComponent={SortableRow}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
